import { capturesDeleted, deleteItemRpcArgs, sourceCapturesFrom } from '@cerebro-diem/core';
import type { ItemKind, SourceCapture } from '@cerebro-diem/core';
import { supabase } from './supabase';

/** The captures a task or note was filed from: usually one, none when it was made by hand. */
export async function sourceCaptures(kind: ItemKind, itemId: string): Promise<SourceCapture[]> {
  const { data, error } = await supabase
    .from('classifications')
    .select('capture_id, captures(raw_text)')
    .eq('category', kind)
    .eq('destination_id', itemId);
  if (error) throw error;
  return sourceCapturesFrom(data);
}

/**
 * Delete the signed-in user's task or note and, when `withCapture`, the
 * capture it was filed from, in one database call (delete_item). A capture
 * that is kept goes back to the Inbox for review. Returns how many captures
 * were deleted; throws when the item is not found.
 */
export async function deleteItem(kind: ItemKind, id: string, withCapture: boolean): Promise<number> {
  const { data, error } = await supabase.rpc('delete_item', deleteItemRpcArgs(kind, id, withCapture));
  if (error) throw error;
  return capturesDeleted(data);
}
